export const environment = {
  production: true,
  devapis: "https://docs.globalhuntindia.com",
  deviosapi:"https://apis.globalhuntindia.com",
  apiKey:{'x-api-key':'X6rQMpTehO3Jae99BpZK68FxHeMFY2za6roEkN5g'},
  iSearch:"https://isearch.globalhuntindia.com"
};